export function dividend(numerator, denominator) {
  if (denominator === 0) { return 0; }
  if (numerator === 0) { return 0; }
  const quotient = numerator / denominator;
  return Number((quotient).toFixed(4));
}

export function percentage(numerator, denominator) {
  if (denominator === 0) { return 0; }
  if (numerator === 0) { return 0; }
  const quotient = numerator / denominator;
  return Number((quotient * 100).toFixed(1));
}

export function toQueryString(urlPara) {
  return Object.keys(urlPara).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(urlPara[key])}`).join('&');
}
